import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  TextField,
  Avatar,
  IconButton,
  Paper,
  Divider
} from '@mui/material';
import { Edit } from '@mui/icons-material';
import { useSelector } from 'react-redux';

const ProfileScreen = () => {
  const { auth } = useSelector((store) => store);
  const user = {
    firstName: auth?.user?.firstName || '',
    lastName: auth?.user?.lastName || '',
    email: auth?.user?.email || '',
    phone: auth?.user?.mobile || '',
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#ffffff', // full white background
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 4,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={4}
          sx={{
            borderRadius: 4,
            p: 4,
            bgcolor: '#fff',
            minHeight: '80vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Grid container spacing={3}>
            {/* Avatar + Heading */}
            <Grid item xs={12} container alignItems="center" spacing={2}>
              <Grid item>
                <Avatar sx={{ width: 80, height: 80, bgcolor: '#1976d2', fontSize: 28 }}>
                  {user.firstName?.[0]}
                  {user.lastName?.[0]}
                </Avatar>
              </Grid>
              <Grid item xs>
                <Typography variant="h5" fontWeight="bold">
                  {user.firstName} {user.lastName}
                </Typography>
              </Grid>
              {/* <Grid item>
                <IconButton color="primary" aria-label="edit profile">
                  <Edit />
                </IconButton>
              </Grid> */}
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            {/* Profile Fields */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="First Name"
                value={user.firstName}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Last Name"
                value={user.lastName}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email Address"
                value={user.email}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Phone Number"
                value={user.phone}
                InputProps={{ readOnly: true }}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

export default ProfileScreen;
